import { Popover, Button, OverlayTrigger } from "react-bootstrap";

function DetallePopOver({ detalle, nombre, apellido }) {
  const popover = (
    <Popover id="popover-basic">
      <Popover.Header as="h6">
        {nombre} {apellido}
      </Popover.Header>
      <Popover.Body>{detalle ? detalle : "No hay detalle"}</Popover.Body>
    </Popover>
  );

  const Example = () => (
    <OverlayTrigger trigger="click" placement="left" overlay={popover}>
      <Button variant="outline-dark" size="sm">
        detalle
      </Button>
    </OverlayTrigger>
  );

  return <Example />;
}

export default DetallePopOver;
